import { useTranslations } from "use-intl";
import ReferencePicker from "./reference-picker";
import type { WorkflowReferenceAction } from "@/types/workflow-reference.types";

export interface KnowledgePickerProps {
  value: string[];
  onChange: (ids: string[]) => void;
  disabled?: boolean;
  placeholder?: string;
  action?: WorkflowReferenceAction;
  nodeType?: string;
  fieldKey?: string;
}

export function KnowledgePicker({
  value,
  onChange,
  disabled,
  placeholder,
  action = "read",
  nodeType,
  fieldKey = "knowledge_ids",
}: KnowledgePickerProps) {
  const t = useTranslations("workflows");

  return (
    <ReferencePicker
      kind="knowledge"
      action={action}
      nodeType={nodeType}
      fieldKey={fieldKey}
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder={placeholder ?? t("drawer.reference.search_knowledge")}
    />
  );
}

export default KnowledgePicker;
